var stickObject = {
    "playerGoalieSticks": [
        {
            "SKU": "688698552195",
            "VariantID": "43261134242030"
        },{
            "SKU": "688698403497",
            "VariantID": "42997152678126"
        },{
            "SKU": "688698552188",
            "VariantID": "43261132800238"
        },{
            "SKU": "688698403503",
            "VariantID": "42997152710894"
        },{
            "SKU": "688698403510",
            "VariantID": "42997152743662"
        },{
            "SKU": "688698403527",
            "VariantID": "42997152776430"
        },{
            "SKU": "688698403534",
            "VariantID": "42997152841966"
        },{
            "SKU": "688698403541",
            "VariantID": "42997152874734"
        },{
            "SKU": "688698403558",
            "VariantID": "42997152907502"
        },{
            "SKU": "688698403565",
            "VariantID": "42997152940270"
        },{
            "SKU": "688698403572",
            "VariantID": "42997152973038"
        },{
            "SKU": "688698402148",
            "VariantID": "42997152514286"
        },{
            "SKU": "688698402155",
            "VariantID": "42997152579822"
        },{
            "SKU": "688698402162",
            "VariantID": "42997152612590"
        },{
            "SKU": "688698403589",
            "VariantID": "43261634183406"
        },{
            "SKU": "688698403596",
            "VariantID": "42997153071342"
        },{
            "SKU": "688698403602",
            "VariantID": "42997153104110"
        },{
            "SKU": "688698342093",
            "VariantID": "42997147730158"
        },{
            "SKU": "688698402070",
            "VariantID": "42997152481518"
        },{
            "SKU": "688698342086",
            "VariantID": "42997147697390"
        },{
            "SKU": "688698402049",
            "VariantID": "42997152350446"
        },{
            "SKU": "688698402056",
            "VariantID": "42997152415982"
        },{
            "SKU": "688698465945",
            "VariantID": "42997157593326"
        },{
            "SKU": "688698465938",
            "VariantID": "42997157560558"
        },{
            "SKU": "688698423495",
            "VariantID": "42997153759470"
        },{
            "SKU": "688698423501",
            "VariantID": "42997153792238"
        },{
            "SKU": "688698423518",
            "VariantID": "42997153825006"
        },{
            "SKU": "688698424478",
            "VariantID": "42997153890542"
        },{
            "SKU": "688698424461",
            "VariantID": "42997153857774"
        },{
            "SKU": "688698424485",
            "VariantID": "42997153923310"
        },{
            "SKU": "688698507157",
            "VariantID": "42997163524334"
        },{
            "SKU": "688698507140",
            "VariantID": "42997163491566"
        },{
            "SKU": "688698507133",
            "VariantID": "42997163458798"
        },{
            "SKU": "688698507126",
            "VariantID": "42997163426030"
        },{
            "SKU": "688698483369",
            "VariantID": "42997158904046"
        },{
            "SKU": "688698483376",
            "VariantID": "42997158936814"
        },{
            "SKU": "688698483994",
            "VariantID": "42997159461102"
        },{
            "SKU": "688698484007",
            "VariantID": "42997159493870"
        },{
            "SKU": "688698503999",
            "VariantID": "42997163000046"
        },{
            "SKU": "688698504002",
            "VariantID": "42997163032814"
        },{
            "SKU": "688698504019",
            "VariantID": "42997163065582"
        },{
            "SKU": "688698554083",
            "VariantID": "42997168963822"
        },{
            "SKU": "688698554090",
            "VariantID": "42997168996590"
        },{
            "SKU": "688698552164",
            "VariantID": "43261130506478"
        },{
            "SKU": "688698552171",
            "VariantID": "43261132144878"
        },{
           "SKU":"688698616125",
           "VariantID":"43791706194158"
        },
        {
           "SKU":"688698616156",
           "VariantID":"43791706161390"
        },
        {
           "SKU":"688698616132",
           "VariantID":"43791706095854"
        },
        {
           "SKU":"688698616149",
           "VariantID":"43791706128622"
        },
      {
           "SKU":"688698614237",
           "VariantID":"44177101127918"
        },
      {
           "SKU":"688698614220",
           "VariantID":"44177101062382"
        },
      {
           "SKU":"688698614244",
           "VariantID":"44177101160686"
        },
      {
           "SKU":"688698614251",
           "VariantID":"44177101095150"
        },
        {
           "SKU":"688698621334",
           "VariantID":"44232203698414"
        },
        {
           "SKU":"688698621341",
           "VariantID":"44232203665646"
        },
        {
           "SKU":"688698621358",
           "VariantID":"44232203731182"
        },
        {
           "SKU":"688698621365",
           "VariantID":"44232203763950"
        },
        {
           "SKU":"688698403589",
           "VariantID":"43261634183406"
        },
        {
           "SKU":"688698403596",
           "VariantID":"42997153071342"
        },
        {
           "SKU":"688698403602",
           "VariantID":"42997153104110"
        },
        {
            "SKU":"688698648607",
            "VariantID":"44384656949486"
         },
         {
            "SKU":"688698648621",
            "VariantID":"44384656851182"
         },
         {
            "SKU":"688698648614",
            "VariantID":"44384656883950"
         },
         {
            "SKU":"688698648591",
            "VariantID":"44384656916718"
         },
      {
            "SKU":"688698684247",
            "VariantID":"44705393639662"
         },
      {
            "SKU":"688698684230",
            "VariantID":"44705393705198"
         },
      {
            "SKU":"688698705935",
            "VariantID":"44705393672430"
         },
      {
            "SKU":"688698673067",
            "VariantID":"45558637953262"
         },
      {
            "SKU":"688698673036",
            "VariantID":"45558637986030"
         },
      {
            "SKU":"688698673050",
            "VariantID":"45558638018798"
         },
      {
            "SKU":"688698673043",
            "VariantID":"45558637920494"
         },
      {
            "SKU":"688698763973",
            "VariantID":"45933073203438"
         },
       {
            "SKU":"688698763966",
            "VariantID":"45933073137902"
         },
       {
            "SKU":"688698763959",
            "VariantID":"45933073170670"
         },
      {
            "SKU":"688698763980",
            "VariantID":"45933073105134"
         },
      {
            "SKU":"688698763997",
            "VariantID":"45933073268974"
         }
    ],
    "quickTurnSticks": [
        {
            "SKU": "ULTRAS_LP_JR5",
            "VariantID": "43261355884782"
        },
        {
            "SKU": "ULTRAS_LP_JR4",
            "VariantID": "43261357785326"
        },
        {
            "SKU": "HYPERL_LP_SR",
            "VariantID": "43261360472302"
        },
        {
            "SKU": "HYPERL_LP_INT",
            "VariantID": "43261375545582"
        },
        {
            "SKU": "HYPERL_LP_JR5",
            "VariantID": "43261377347822"
        },
        {
            "SKU": "HYPERL_LP_JR4",
            "VariantID": "43261378527470"
        },
        {
            "SKU": "SYNCN_LP_SR",
            "VariantID": "43261383835886"
        },
        {
            "SKU": "SYNCN_LP_INT",
            "VariantID": "43261391339758"
        },
        {
            "SKU": "SYNCN_LP_JR5",
            "VariantID": "43261393633518"
        },
        {
            "SKU": "SYNCN_LP_JR4",
            "VariantID": "43261398745326"
        },
        {
          "SKU": "ULTRAS_LP_SR",
          "VariantID": "43066802372846"
        },
        {
          "SKU": "ULTRAS_LP_INT",
          "VariantID": "43066802340078"
        },
        {
          "SKU": "HYPERL2_LP_SR",
          "VariantID": "44241326768366"
        },
        {
          "SKU": "HYPERL2_LP_INT",
          "VariantID": "44241328111854"
        },
        {
          "SKU": "HYPERL2_LP_JR5",
          "VariantID": "44241334436078"
        },
        {
          "SKU": "HYPERL2_LP_JR4",
          "VariantID": "44241333190894"
        },
        {
            "SKU": "PROTOR_LP_INT",
            "VariantID": "44384657015022"
          },
          {
            "SKU": "PROTOR_LP_JR4",
            "VariantID": "44384657080558"
          },
          {
            "SKU": "PROTOR_LP_JR5",
            "VariantID": "44384657047790"
          },
          {
            "SKU": "PROTOR_LP_SR",
            "VariantID": "44384656982254"
          }
    ]
};

var bladeObject = {
    "blades": [
        {
        "SKU": "688698463569",
        "VariantID": "42997156643054"
      },
      {
        "SKU": "688698463576",
        "VariantID": "42997156675822"
      },
      {
        "SKU": "688698512878",
        "VariantID": "42997164900590"
      },
      {
        "SKU": "688698627046",
        "VariantID": "44184710152430"
      },
      {
        "SKU": "688698627039",
        "VariantID": "44184710119662"
      }
    ]
};

var skateObject = {
    "skates": [
        {
            "SKU": "688698582178",
            "VariantID": "42997170438382"
        },
        {
            "SKU":"688698582154",
            "VariantID":"42997170340078"
        },
        {
            "SKU":"688698582215",
            "VariantID":"42997170602222"
        }, 
        {
            "SKU":"688698582147",
            "VariantID":"42997170307310"
        },
        {
            "SKU":"688698582208",
            "VariantID":"42997170536686"
        },
        {
            "SKU":"688698582192",
            "VariantID":"42997170503918"
        },
        {
            "SKU":"688698582185",
            "VariantID":"42997170471150"
        },
        {
            "SKU":"688698582161",
            "VariantID":"42997170405614"
        },
        {
            "SKU":"688698512861",
            "VariantID":"42997164867822"
        },
        {
            "SKU":"688698512854",
            "VariantID":"42997164835054"
        },
        {
            "SKU":"688698512847",
            "VariantID":"42997164802286"
        },
        {
            "SKU":"688698512830",
            "VariantID":"42997164703982"
        },
        {
            "SKU":"688698512823",
            "VariantID":"42997164638446"
        },
        {
            "SKU":"688698512816",
            "VariantID":"42997164605678"
        },
        {
            "SKU":"688698512809",
            "VariantID":"42997164572910"
        },
       {
            "SKU":"688698512793",
            "VariantID":"42997164507374"
        },
       {
            "SKU":"688698512113",
            "VariantID":"42997164474606"
        },
        {
            "SKU":"688698511796",
            "VariantID":"42997164179694"
        },
        {
            "SKU":"688698511789",
            "VariantID":"42997164146926"
        },
        {
            "SKU":"688698390636",
            "VariantID":"42997151105262"
        },
      {
            "SKU":"688698595666",
            "VariantID":"44177101258990"
        },
      {
            "SKU":"688698595680",
            "VariantID":"44177101291758"
        },
      {
            "SKU":"688698595673",
            "VariantID":"44177101193454"
        },
      {
            "SKU":"688698595659",
            "VariantID":"44177101226222"
        }
    ],
    "blades": [
    {
        "BladeType": "LS Pulse Ti",
        "SKU": "688698463569",
        "VariantID": "42997156643054"
      },
      {
        "BladeType": "LS Pulse TI",
        "SKU": "688698463569",
        "VariantID": "42997156643054"
      },
      {
        "BladeType": "LS Pulse",
        "SKU": "688698463576",
        "VariantID": "42997156675822"
      },
      {
        "BladeType": "LS CarbonLite",
        "SKU": "688698512878",
        "VariantID": "42997164900590"
      },
      {
        "BladeType": "FLY-TI",
        "SKU": "688698627039",
        "VariantID": "44184710119662"
      },
      {
        "BladeType": "FLY-X",
        "SKU": "688698627046",
        "VariantID": "44184710152430"
      }
    ]
};
// Initialize myBauer stick object
window.addEventListener("DOMContentLoaded", function() {
    stickObject;
    bladeObject;
    skateObject;
})